import { FC } from 'react';

import { BlogSectionType } from '../../../models/Content';
import { StyledSectionImage } from './SectionImage.styles';
import { transformSectionImage } from './transformers';

type Props = {
    contentItem: BlogSectionType;
};

export const SectionImage: FC<Props> = ({ contentItem }) => {
    const { url, alt } = transformSectionImage(contentItem);

    if (!url) {
        return null;
    }

    return <StyledSectionImage src={url} alt={alt} />;
};
